<template>
  <div class="login position-relative">
    <video autoplay muted loop class="main_video">
      <source src="/images/wallet.mp4" type="video/mp4" />
      <source src="/images/wallet.mp4" type="video/ogg" />
    </video>
    <div class="login_inner">
      <img src="/images/logo.png" class="logo" alt="" />
      <div v-if="!production">
        <div class="rpc-server-wrapper">
          <RpcServer />
        </div>
        <button
          type="button"
          class="btn btn-success mt-5 w-50 py-3"
          @click.prevent="handle_login"
        >
          Login
        </button>
      </div>
      <div v-else>
        <h2>Comming Soon.</h2>
      </div>
      <p class="text-center mt-5">
        "By using or accessing our website you agree to our
        <a href="https://whitepaper.wildwestgame.io/">Terms of Use</a>"
      </p>

      <div id="ual-div"></div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import RpcServer from "../components/RpcServer.vue";
import LoginService from "../services/LoginService";
export default {
  name: "Login",
  components: {
    RpcServer,
  },
  data() {
    return {
      ual: null,
      showPopup: false,
      production: false,
    };
  },
  inheritAttrs: false,
  mounted() {
    if (window.location.host == "play.wildwestgame.io") {
      this.production = true;
    } else {
      localStorage.removeItem("ual-session-authenticator");
      localStorage.removeItem("ual-session-expiration");
      localStorage.removeItem("autoLogin");
      localStorage.removeItem("loglevel:webpack-dev-server");
      localStorage.removeItem("ual-wax:autologin");
      localStorage.removeItem("wax_user");
      localStorage.clear();
      const loginService = new LoginService();
      this.ual = loginService.handle_login();
    }
  },
  methods: {
    handle_login: function () {
      var [buttonUAL] = document.body.getElementsByClassName("ual-button-gen");
      if (this.ual) {
        this.ual.init();
        buttonUAL.click();
        let elements = document.body.getElementsByClassName("ual-button-gen");
        while (elements.length > 0) {
          elements[0].parentNode.removeChild(elements[0]);
        }
      } else {
        const loginService = new LoginService();
        this.ual = loginService.handle_login();
        this.ual.init();
        buttonUAL.click();
        let elements = document.body.getElementsByClassName("ual-button-gen");
        while (elements.length > 0) {
          elements[0].parentNode.removeChild(elements[0]);
        }
      }
    },
  },
};
</script>

<style>
.ual-button-gen {
  display: none !important;
}
.ual-auth-text {
  display: inline-block !important;
  padding: 20px 4px 17px 10px !important;
  font-size: 10px !important;
  width: 137px !important;
}

.fa-chevron-right {
  font-size: 16px !important;
  float: right;
  margin: 12px 6px;
}

.ual-modal-content-description {
  /* color:#fff !important; */
  width: 246px !important;
  font-size: 1.2em !important;
  margin: 0.7em auto;
}
.logo {
  width: 300px;
}
.login {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  justify-content: center;
}
.main_video {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  min-width: 100%;
  min-height: 100%;
}
.login_inner {
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  left: 0;
  right: 0;
  width: 40%;
  text-align: center;
  display: table;
}

.rpc-server-wrapper {
  margin: 38px auto 0 auto;
  width: 100%;
}
@media (max-width: 768px) {
  .login_inner {
    width: 100%;
  }
}
</style>